// Explaination for shorten words:
// -RID-: Requestor Id
// -HID-: Hospital Id
// -HIDs-: Hospital Ids
// -UID-: User Id
// -T-: Type
// -D-: Date
// -Br-: Brand
// -TZ-: Timezone
// -Page-: Page
// -Pn: Page Number
// -Pr: Page Rows
// -Sf: Sort Field
// -So: Sort Order
// -Fr: Filter Request
// -List-: List
// -R: Rows Option
// -S: Simple
// -Detail-I: Detail Id
// -Detail-U: Detail UserId
// -Country-: Country
// -States-: States
// -Cities-: Cities

import {genericLogQueryType} from '../components/styled-component/generic-log/GenericLogConstansts'
import {UserPropertyType} from '../components/user-property/UserPropertyConstants'

export const QueryActionTypes = {
    replace: 'replace',
    append: 'append',
}

export const QueryCRUDTypes = {
    create: 'create',
    update: 'update',
    delete: 'delete',
}

export const QueryKeyManager = (type, requestorId) => {
    const convertedType =
        type && type?.length > 0
            ? type.charAt(0).toUpperCase() + type.slice(1)
            : type

    //#region Generic
    const genericKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Authentication
    const authKeys = {
        pattern: () => [`${convertedType}`],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region App Config
    const appConfigKeys = {
        pattern: () => [`${convertedType}`],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Role Permissions
    const rolePermissionKeys = {
        pattern: () => [`${convertedType}`],

        // This is used for getting the list of roles for management
        list: ({simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        // This is used for getting the list of roles for specific user
        detail: ({id, hospitalId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HID-${hospitalId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Notification
    const notificationKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            hospitalId = 0,
            type,
            timezoneId,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HID-${hospitalId}`,
            `-T-${type}`,
            `-TZ-${timezoneId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        customCount: ({hospitalId = null, timezoneId, filterRequest}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-TZ-${timezoneId}`,
            `-CustomCount-`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Static List
    const staticListKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        // Options List || Dashboard Static List
        list: ({simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
        // This is used for notification settings
        userList: ({type, hospitalIds}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Type-${type}`,
            `-List-`,
            `-Fr/${hospitalIds ? JSON.stringify(hospitalIds) : ''}`,
        ],
    }
    //#endregion

    //#region Pathway
    const pathwayKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Hospital
    const hospitalKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        sectionList: ({filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-SectionList-`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region General Practitioner
    const generalPractitionerKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Support Team
    const supportTeamKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            hospitalId = null,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({hospitalId = null, simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
    }
    //#endregion

    //#region Patient
    const patientKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            hospitalId = null,
            timezoneId,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-TZ-${timezoneId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({hospitalIds = [], simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalIds}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        customList: ({
            hospitalId = null,
            timezoneId,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'sicknessLevel',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-TZ-${timezoneId}`,
            `-CustomList-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        customCount: ({hospitalId = null, timezoneId, filterRequest}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-TZ-${timezoneId}`,
            `-CustomCount-`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        sectionList: ({
            hospitalIds = [],
            staticListIds = [],
            pathwayIds = [],
            mainRefId = null,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalIds}`,
            `-SectionList-`,
            `-SLIDs-${staticListIds}`,
            `-PIDs-${pathwayIds}`,
            `-MRID-${mainRefId}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Address
    const addressKeys = {
        pattern: () => [`${convertedType}`],
        country: () => [`${convertedType}`, '-Country-'],
        states: ({countryCode}) => [
            `${convertedType}`,
            '-States-',
            `C/${countryCode}1`,
        ],
        cities: ({countryCode, stateCode}) => [
            `${convertedType}`,
            '-Cities-',
            `C/${countryCode}`,
            `-S/${stateCode}`,
        ],
    }
    //#endregion

    //#region HCP
    const healthCareKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            hospitalId = null,
            timezoneId,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-TZ-${timezoneId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({simple, rows, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-R/${rows}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Chart
    const chartTypes = {
        activeDevice: 'activeDevice',
        userStatistic: 'userStatistic',
        userECG: 'userECG',
    }

    // This is used for Chart
    const chartKeys = {
        pattern: () => [`${convertedType}`],
        activeDevice: ({hospitalId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-T-${chartTypes.activeDevice}`,
            `-HID-${hospitalId}`,
            `-List-`,
        ],
        userStatistic: ({hospitalId, year}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HID-${hospitalId}`,
            `-T-${chartTypes.userStatistic}`,
            `-List-`,
            `-Fr/${year ? JSON.stringify({year: year}) : ''}`,
        ],
        userECG: ({brand}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-T-${chartTypes.userECG}`,
            `-List-`,
            `-Fr/${brand ? JSON.stringify({brand: brand}) : ''}`,
        ],
    }
    //#endregion

    //#region User Property
    const userPropertyKeys = {
        pattern: ({type}) => [`${convertedType}`, `-T-${type}`],
        list: ({type, simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-T-${type}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        page: ({
            type,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-T-${type}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        symptomsPathway: ({userId}) => [
            `${convertedType}`,
            `-T-${UserPropertyType.symptomsPathway}`,
            `-RID-${requestorId}`,
            `-UID-${userId}`,
            `-List-`,
        ],
    }
    //#endregion

    //#region User Role
    const userRoleKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
    }
    //#endregion

    //#region Client
    const clientKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
        config: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-T-watchConfig`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Profile
    const profileKeys = {
        pattern: () => [`${convertedType}`],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Note
    const noteKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Relevant Contact
    const nextOfKinKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Examination
    const examinationKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detail: ({id}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-I/${id}`,
        ],
    }
    //#endregion

    //#region Parameter
    const parameterKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detailByUser: ({userId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Discharge Information
    const dischargeKeys = {
        pattern: () => [`${convertedType}`],
        detailByUser: ({userId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Reminder
    const reminderKeys = {
        pattern: () => [`${convertedType}`],
        list: ({timezoneId, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-TZ-${timezoneId}`,
            `-List-`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        recipientsOptions: ({userId}) => [
            `${convertedType}`,
            `-Detail-U/${userId}`,
            `-RecipientsOptions-`,
        ],
        listManagement: ({requestorId, hospitalId, type}) => [
            `${convertedType}`,
            `-appointmentList-`,
            `-RID-${requestorId}`,
            `-T/${type}`,
        ],
    }
    //#endregion

    //#region Watch Config
    const watchConfigKeys = {
        pattern: () => [`${convertedType}`],
        detailByUser: ({userId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Network Suggestion
    const networkSuggestionsKeys = {
        pattern: () => [`${convertedType}`],
        detailByUser: ({userId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Summary
    const summaryKeys = {
        pattern: () => [`${convertedType}`],
        detailByUser: ({userId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Biometric
    const biometricsKeys = {
        pattern: () => [`${convertedType}`],
        detailByUser: ({userId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Health Record
    const healthRecordKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        chartData: ({userId, day}) => [
            `${convertedType}`,
            `-CHART-IN-${day}D-`,
            `-RID-${requestorId}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Health Activities
    const healthActivitiesKeys = {
        pattern: () => [`${convertedType}`],
        // Used For Get Newest Heath Records in Statistic Chart
        listNewest: ({userId, typeCategory}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-T-listNewest-${typeCategory}`,
            `-List-`,
        ],
        // Used For Get Heath Records in Date in Statistic Chart
        listInDate: ({userId, date, type}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-T-listInDate-${type}`,
            `-D-${date}`,
            `-List-`,
        ],
        // Used For Get Heath Record Latest in Statistic Chart Patient Dashboard
        newest: ({userId}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-T-newest`,
            `-Detail-U/${userId}`,
        ],
        pageActivities: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-T-pageActivities`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
    }
    //#endregion

    //#region ECG
    const ecgKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        detailByUser: ({userId, brand}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-Br-${brand}`,
            `-Detail-U/${userId}`,
        ],
    }
    //#endregion

    //#region Generic Log
    const genericLogKeys = {
        pattern: ({type = genericLogQueryType.none}) => [
            `${convertedType}`,
            `-T-${type}`,
        ],
        page: ({
            type = genericLogQueryType.none,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-T-${type}`,
            `-RID-${requestorId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
    }
    //#endregion

    //#region  Configuration
    const additionalNotifyMethodKeys = {
        pattern: () => [`${convertedType}`],
        page: ({
            hospitalId = null,
            pageNumber = 0,
            pageRows = 10,
            sortField = 'id',
            sortOrder = -1,
            filterRequest,
        }) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-Page-`,
            `-Pn/${pageNumber}`,
            `-Pr/${pageRows}`,
            `-Sf/${sortField}`,
            `-So/${sortOrder}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
        list: ({hospitalId = null, simple, filterRequest = {}}) => [
            `${convertedType}`,
            `-RID-${requestorId}`,
            `-HIDs-${hospitalId}`,
            `-List-`,
            `-S/${simple}`,
            `-Fr/${filterRequest ? JSON.stringify(filterRequest) : ''}`,
        ],
    }
    //#endregion
    return {
        ecgKeys,
        noteKeys,
        authKeys,
        chartKeys,
        clientKeys,
        genericKeys,
        pathwayKeys,
        summaryKeys,
        patientKeys,
        addressKeys,
        profileKeys,
        reminderKeys,
        hospitalKeys,
        userRoleKeys,
        appConfigKeys,
        parameterKeys,
        nextOfKinKeys,
        dischargeKeys,
        staticListKeys,
        healthCareKeys,
        biometricsKeys,
        genericLogKeys,
        watchConfigKeys,
        supportTeamKeys,
        examinationKeys,
        notificationKeys,
        healthRecordKeys,
        userPropertyKeys,
        networkSuggestionsKeys,
        rolePermissionKeys,
        healthActivitiesKeys,
        generalPractitionerKeys,
        additionalNotifyMethodKeys,
    }
}
